module.exports = __webpack_public_path__ + "media/img/favicon-32x32-9d56556703eb919621278bf6c01f60ba.png";